import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserManagerDataModule } from '../browser-manager-data/browser-manager-data.module';
import { SharedModule } from '../shared/shared.module';
import { PollerService } from './poller.service';

@NgModule({
  imports: [CommonModule, SharedModule, BrowserManagerDataModule],
  declarations: [],
})
export class PollerModule {
  static forRoot(): ModuleWithProviders<PollerModule> {
    return {
      ngModule: PollerModule,
      providers: [PollerService],
    };
  }
}
